import { Box, Container, Grid, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import banner from '../../../assets/about_2.png'
import tick from '../../../assets/tick-blue - Copy.png';

export default function About() {
    return (
        <Box py={6} sx={{ background: 'linear-gradient(#E7F0FF, #E8F1FF)' }}>
            <Container>
                <Grid container spacing={6} alignItems='center'>

                    <Grid item xs={12} md={6}>
                        <Box
                            component='img'
                            src={banner}
                            width={1}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography
                            fontWeight={600}
                            color="primary.main"
                        >
                        </Typography>
                        <Typography variant="h2" mb={1}>
                        <span style={{ color: '#262262' }}>About</span>
                        <span style={{ color: '#ED1C24' }}>Us</span>
                        </Typography>
                        <Typography color='#77829D' lineHeight={1.6} textAlign="justify"
                                    sx={{ textJustify: 'inter-word' }}>
                            Urgent care provides immediate medical attention for non-life-threatening conditions like chest pain, breathing difficulties, minor fractures, infections, cuts, burns, stomachaches, and flu symptoms. It offers a faster, cost-effective alternative to emergency rooms, with walk-in services and minimal wait times. Operating beyond regular clinic hours, urgent care centers provide diagnostic services like X-rays and lab tests for prompt treatment.
                            <br/>
                            VEM Plus Urgent Care is a trusted facility offering high-quality, immediate healthcare for urgent but non-life-threatening conditions. Our experienced team ensures fast, compassionate, and personalized care for all ages. We prioritize patient well-being, delivering efficient and affordable medical services when you need them most.
                        </Typography>

                        <List sx={{ fontSize: { xs: 12, md: 18 } }}>
                            <ListItem disableGutters>
                                <ListItemIcon sx={{ minWidth: 32 }}>
                                    <Box component='img' src={tick} height={22} width={22} />
                                </ListItemIcon>
                                <ListItemText
                                    primary='Stay Updated About Your Health'
                                    primaryTypographyProps={{ fontSize: { xs: 14, md: 18 }, fontWeight: 500, color: '#262262' }}
                                />
                            </ListItem>
                        </List>

                    </Grid>

                </Grid>
            </Container>
        </Box>
    )
}
